import {Entity} from '../core/main.entity';

export class Country extends Entity {
  id: number;
  title: string;
}
